module.exports = __webpack_public_path__ + "img/banner4行业动态 手机端.4fc69263.jpg";